import axios from "axios";

const generateHeader = () => {
  const token = global.localStorage.authToken;
  const header = {
    Authentication: token ? `Bearer ${token}` : undefined,
  };

  if (token && global.localStorage.viewingAs) {
    header.ViewingAs = JSON.parse(global.localStorage.viewingAs).id;
  }

  if (token && global.localStorage.ghosting) {
    header.ghosting = global.localStorage.ghosting;
  }

  return header;
};

const handleTokenError = (error) => {
  const { response } = error;
  if (response.status === 401) {
    if (response.data.error === "INVALID_TOKEN") {
      window.dispatchEvent(new Event("token_expired"));
      return;
    }
  }

  throw error; // rethrow the error so it can be caught by the caller
};

export const GET = (url, config = {}) =>
  axios({
    method: "GET",
    url,
    ...config,
    headers: { ...generateHeader(), ...(config.headers || {}) },
  }).catch(handleTokenError);

export const POST = (url, data) =>
  axios({
    method: "POST",
    headers: generateHeader(),
    url,
    data,
  }).catch(handleTokenError);

export const PATCH = (url, data) =>
  axios({
    method: "PATCH",
    headers: generateHeader(),
    url,
    data,
  }).catch(handleTokenError);

export const DELETE = (url) =>
  axios({
    method: "DELETE",
    headers: generateHeader(),
    url,
  }).catch(handleTokenError);

export const fetchActivePreferredStaffingFirms = (reportType = "temp") =>
  GET(
    `/api/v3/employer/preferred_links/active_staffing_firms?report_type=${reportType}`
  );

export const fetchEmployerCostCenters = () =>
  GET("/api/v3/employer/cost_centers");

export const fetchEmployerCostCentersForReporting = () =>
  GET("/api/v3/employer/cost_centers?include_invoiced_deleted=true");
